export default "__VITE_ASSET__40wCAcnz__"